import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router'

import { routeName } from '~/@common/constants'
import { nativeEventBus } from '~/@common/services/nativeEventBus'
import { webviewService } from '~/@common/services'

export const useNativeBackHandler = () => {
  const navigate = useNavigate()

  const memoizedPopState = useCallback(() => navigate(-1), [])

  useEffect(() => {
    // 기존 사용성에 따라 아래의 라우트들에서 뒤로가기 버튼을 누르면 앱이 종료되도록 설정
    const primaryRoute = [
      routeName.login,
      routeName.student.defaultPath,
      routeName.student.challenge,
      routeName.student.generalStudentWorkbookList,
      routeName.student.studentWorksheet,
      routeName.student.lectureList,
      routeName.parent.defaultPath,
      routeName.parent.attendance,
      routeName.parent.report,
      routeName.parent.notice,
    ]

    const isPrimaryRoute = primaryRoute.some((route) => route === location.pathname)

    const handler = isPrimaryRoute
      ? () => webviewService.closeApp()
      : memoizedPopState

    const unsub = nativeEventBus.subscribe('onBackPressed', handler)

    return unsub
  }, [location.pathname, memoizedPopState])
}
